export default __webpack_public_path__ + "static/media/ModoSobDemanda.525806a0.png";